import { PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'
import { useLayout } from 'stores/LayoutStore'
import { Portal } from 'components/Portal/Portal'

export const MobileWriterToolbar = observer(({ children }: PropsWithChildren) => {
  const layout = useLayout()

  if (!layout.mobileWriterToolbar) return null

  return <Portal container={layout.mobileWriterToolbar}>{children}</Portal>
})
